/**
 * Defines an action to be executed when a state is activated.
 */
export class Action {
    static $inject = ['init'];
    constructor(init) {
        Object.assign(this, init);
    }
}
export var ActionType;
(function (ActionType) {
    ActionType["SendMessage"] = "SendMessage";
    ActionType["SendRawMessage"] = "SendRawMessage";
    ActionType["SendMessageFromHttp"] = "SendMessageFromHttp";
    ActionType["TrackEvent"] = "TrackEvent";
    ActionType["ProcessHttp"] = "ProcessHttp";
    ActionType["ManageList"] = "ManageList";
    ActionType["MergeContact"] = "MergeContact";
    ActionType["Redirect"] = "Redirect";
    ActionType["ExecuteScript"] = "ExecuteScript";
    ActionType["ExecuteScriptV2"] = "ExecuteScriptV2";
    ActionType["ExecuteTemplate"] = "ExecuteTemplate";
    ActionType["ForwardMessageToDesk"] = "ForwardMessageToDesk";
    ActionType["ForwardToDesk"] = "ForwardToDesk";
    ActionType["LeavingFromDesk"] = "LeavingFromDesk";
    ActionType["SetVariable"] = "SetVariable";
    ActionType["DeleteVariable"] = "DeleteVariable";
    ActionType["ProcessCommand"] = "ProcessCommand";
    ActionType["CreateTicket"] = "CreateTicket";
    ActionType["ProcessContentAssistant"] = "ProcessContentAssistant";
    ActionType["SurveyType"] = "SurveyMessage";
    ActionType["TrackContactsJourney"] = "TrackContactsJourney";
    ActionType["ProcessAnswers"] = "ProcessAnswers";
    ActionType["ExecuteBlipFunction"] = "ExecuteBlipFunction";
    ActionType["ForwardToAgent"] = "ForwardToAgent";
    ActionType["LeavingFromAgent"] = "LeavingFromAgent";
})(ActionType || (ActionType = {}));
